<template>
  <li :class="classes" @mouseenter="$_onSubMenuMouseenter" @mouseleave="$_onSubMenuMouseleave">
    <div ref="reference" :class="`${prefixMenuClass}__submenu-title`" @click.stop="$_onSubMenuClick($event)">
      <slot name="title"></slot>
      <i :class="[prefixMenuClass + '__submenu-title-icon']"></i>
    </div>
    <template v-if="mode === 'vertical' && openPosition === 'down'">
      <t-collapse-transition>
        <ul v-show="opened" :class="submenuClass">
          <slot></slot>
        </ul>
      </t-collapse-transition>
    </template>
    <transition v-else :name="transitionName">
      <ul v-show="opened"
          :style="dropStyle"
          :class="rightModeMenuClass"
          placement="bottom"
          style="margin-top: 0;">
        <slot></slot>
      </ul>
    </transition>
  </li>
</template>
<script>
import { PREFIX_MENU_CLASS } from './constants'
import { getStyle, findComponentUpward } from '../../utils/assist'
import Emitter from '../../mixins/emitter'

export default {
  name: 'TSubmenu',
  mixins: [Emitter],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prefixMenuClass: PREFIX_MENU_CLASS,
      active: false,
      opened: false,
      dropWidth: parseFloat(getStyle(this.$el, 'width')),
      parent: findComponentUpward(this, 'TMenu')
    }
  },
  computed: {
    transitionName() {
      if (this.openPosition === 'right' && this.opened === true) {
        return 'fade'
      } else {
        return ''
      }
    },
    classes() {
      return [
        `${PREFIX_MENU_CLASS}__submenu`,
        {
          [`${PREFIX_MENU_CLASS}__submenu--checked`]: this.active,
          [`${PREFIX_MENU_CLASS}--open dropdown--open`]: this.opened === true,
          [`dropright`]: this.openPosition === 'right',
          [`${PREFIX_MENU_CLASS}__submenu--disabled`]: this.disabled
        }
      ]
    },
    submenuClass() {
      return [
        `${PREFIX_MENU_CLASS}`,
        {
          [`dropdown__menu`]: this.openPosition === 'right',
          [`menu__vertical`]: this.openPosition !== 'right'
        }
      ]
    },
    rightModeMenuClass() {
      return [
        'dropdown__menu'
      ]
    },
    mode() {
      return this.parent.mode
    },
    openPosition() {
      return this.parent.openPosition
    },
    accordion() {
      return this.parent.accordion
    },
    dropStyle() {
      let style = {}

      if (this.dropWidth) style.minWidth = `${this.dropWidth}px`
      return style
    }
  },
  watch: {
    opened(val) {
      // 用于menu的动态效果
      if (this.mode === 'vertical') {
        if (this.openPosition === 'right') {
          this.$nextTick(function() {
            let liHeight = this.$el.offsetHeight || this.$el.clientHeight
            let childUl = this.$el.querySelector('ul')
            let childUlHeight = childUl.offsetHeight || childUl.clientHeight
            let elTop = this.$el.getBoundingClientRect().top
            let windowsHeight = window.innerHeight
            // 向下空间不够时上翻 显示到最底部
            if (elTop + childUlHeight > windowsHeight) {
              childUl.style.top = 'auto'
              childUl.style.bottom =
                elTop - windowsHeight + liHeight + 10 + 'px'
            }
          })
        } else {
          let childUl = this.$el.querySelector('ul')
          childUl.style.top = 0
          childUl.style.bottom = 'auto'
        }
      }
    }
  },
  mounted() {
    this.$on('menu-item-select', name => {
      if (this.mode === 'horizontal' || this.openPosition === 'right') {
        this.opened = false
      }
      this.dispatch('TMenu', 'menu-item-select', name)
      return true
    })
    this.$on('on-update-active-name', status => {
      if (status === false) {
        this.broadcast('TSubmenu', 'on-update-active-name', false)
      } else {
        if (
          this.$parent.$el.classList.toString().indexOf('menu__submenu') > -1
        ) {
          this.$parent.active = true
        }
      }
      this.active = status
    })
  },
  methods: {
    $_onSubMenuMouseenter(evt) {
      if (this.disabled) return
      if (this.mode === 'vertical' && this.openPosition !== 'right') return
      this.parent.updateOpenKeys(this.name)
      this.opened = true
    },
    $_onSubMenuMouseleave(evt) {
      if (this.disabled) return
      if (this.mode === 'vertical' && this.openPosition !== 'right') return
      this.parent.updateOpenKeys(this.name)
      this.opened = false
    },
    $_onSubMenuClick(evt) {
      if (this.disabled) return
      if (this.mode === 'horizontal') return
      if (this.opened === true) { // 委托给父组件统一置opened状态
        this.dispatch('TMenu', 'submenu-close', this.name)
      } else {
        this.dispatch('TMenu', 'submenu-open', this.parentSubMenus(this.name))
      }
    },
    // 获取上级submenu名称
    parentSubMenus() {
      let p = findComponentUpward(this, 'TSubmenu')
      let self = this
      let arr = [this.name]
      while (p) {
        arr.push(p.name)
        p = findComponentUpward(self, 'TSubmenu')
        if (p) {
          self = p
        }
      }
      return {
        submenus: arr
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// submenu.vue?1ffaa88c